export const supportTicketKeys = {
  all: ["support-tickets"] as const,
  lists: () => [...supportTicketKeys.all, "list"] as const,
  list: (filter: string, search = "", page = 1, limit = 10) =>
    [...supportTicketKeys.lists(), filter, search, page, limit] as const,
  details: () => [...supportTicketKeys.all, "detail"] as const,
  detail: (id: string) => [...supportTicketKeys.details(), id] as const,
  systemLists: () => [...supportTicketKeys.all, "system-list"] as const,
  systemList: (filter: string, search = "", page = 1, limit = 20) =>
    [...supportTicketKeys.systemLists(), filter, search, page, limit] as const,
  stats: () => [...supportTicketKeys.all, "stats"] as const,
  systemDetails: () => [...supportTicketKeys.all, "system-detail"] as const,
  systemDetail: (id: string) => [...supportTicketKeys.systemDetails(), id] as const,
  assignees: () => [...supportTicketKeys.all, "assignees"] as const,
};
